/**
 * @module InvoicePurchaseHelper
 */

import axios from 'api/axios'

export class InvoicePurchaseHelper {
  /**
   * Fetches file from purchase invoice
   * @async
   * @param {string} url
   */
  static async fetchFile(url) {
    try {
      return axios.get(url)
    } catch (error) {
      throw new Error(error.message)
    }
  }
}
